module.exports = __webpack_public_path__ + "static/media/default.a6d2fd4f.webp";